<template>
    <div id="errorOverlay" class="overlay">
      <div id="errorModal" class="modal">
        <div id="errorContent" class="modal-content">
          <div id="errorConfirmation" v-html="errorMessage"></div>
          <div id="errorControls">
            <div id="okButton" class="game-button" @click="toggleErrorModal">OK</div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'ErrorModal',
  components: {

  },
  computed: {
    ...mapGetters([
      'moduleTitle',
      'moduleAssetFolderName',
      'errorMessage',
    ]),
  },
  methods: {
    ...mapActions([
      'toggleErrorModal',
    ]),
  },
  mounted(){

  },
  beforeUnmount(){

  },
  data: function(){
    return {

    }
  },
}
</script>

<style >
  #errorOverlay{

  }

  #errorModal{

  }

  #errorContent{

  }

  #errorConfirmation{
    font-size: 26px;
    font-weight: bold;
    color: #f6f6f6;
    padding: 10px 0px;
    width: 80%;
    margin: 20px auto 10px auto;
  }

  #errorControls{
    width: 100%;
    margin: 20px auto;
    display: flex;
    flex: 1;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-evenly;
  }

  #okButton{
    font-size: 24px;
    margin: 5px auto;
  }
  #okButton:hover{
    cursor: pointer;
  }
</style>